function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ChevronDownButton } from './ChevronDownButton';
import { ChevronUpButton } from './ChevronUpButton';
import { CollapseButton } from './CollapseButton';
import { ExpandButton } from './ExpandButton';

// provide text or collapsedText and expandedText
export function ToggleExpandCollapseButton(_ref) {
  let {
    expanded,
    text,
    collapsedText,
    expandedText,
    ...props
  } = _ref;
  if (![true, false].includes(expanded)) {
    console.error('The "expanded" state property is required for the ToggleExpandCollapseButton component.');
  }
  return expanded ? /*#__PURE__*/React.createElement(CollapseButton, _extends({
    variant: "outline-primary"
  }, props, {
    text: collapsedText || text
  })) : /*#__PURE__*/React.createElement(ExpandButton, _extends({
    variant: "primary"
  }, props, {
    text: expandedText || text
  }));
}